export enum ComponentTypeReportingDefaults {
  DTVMARQUEE = "dtvMarquee",
  DTVCAROUSEL = "dtvCarousel",
  CHANNEL_COMPARISON_TOOL = "CHANNEL_COMPARISON_TOOL",
  FAQ = "faqPanel",
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  FAQV2 = "faqPanel",
  // ⚠ EVERY DDS ORGANISM REPORTS UNDER ITS OWN NAME, NEVER A v2 KEY. A v3
  // section is a different component from its nearest v2 counterpart — own
  // markup, own fields, own CMS blok — so sharing a key makes one trend that
  // spans both and cannot be split back apart afterwards. The names below are
  // provisional pending the analytics team; the one-key-per-organism shape is
  // not. Only types already in the v3 ORGANISM_MAP are listed — add one when
  // its organism ships, not before.
  DDS_FAQ = "dds-faq",
  DDS_MARQUEE_MEDIA = "dds-marquee-media",
  DDS_PARALLAX_MARQUEE = "dds-parallax-marquee",
  DDS_MARQUEE_PARALLAX_VIDEO = "dds-marquee-parallax-video",
  DDS_PLAN_CARD_CAROUSEL = "dds-plan-card-carousel",
  DDS_CONTENT_CARD_CAROUSEL = "dds-content-card-carousel",
  DDS_GROW_CARD_CAROUSEL = "dds-grow-card-carousel",
  DDS_CENTER_BANNER = "dds-center-banner",
  DDS_PAGE_SECTION_HEADER = "dds-page-section-header",
  DDS_VERTICAL_SPACER = "dds-vertical-spacer",
  DDS_LEGAL_MODAL = "dds-legal-modal",
  DDS_IN_PAGE_LEGAL = "dds-in-page-legal",
  DDS_COMPARISON_TABLE = "dds-comparison-table",
  DDS_CONTENT_CARD_IMPACT = "dds-content-card-impact",
  DDS_CONTENT_CARD_LARGE = "dds-content-card-large",
  DDS_CONTENT_CARD_SMALL = "dds-content-card-small",
  DDS_CONTENT_CARD_TWO_UP = "dds-content-card-two-up",
  DDS_CONTENT_RIBBON = "dds-content-ribbon",
  // WAT-12320 / WAT-12427: the member with no `ReportingDefaults` row still
  // FIRES its impression — `contentFriendlyName` / `contentProductGroup` are
  // simply absent from the spread (`sb-fixer.ts:156-158`) — so a mapping gap
  // here reports under a blank name instead of throwing or logging. Only the
  // pairing guard in `analytics-mapper.v3.spec.ts` catches it.
  DDS_CHANNEL_LINEUP = "dds-channel-lineup",
  DDS_DYNAMIC_RECOMMENDER = "dds-dynamic-recommender",
  DDS_HP_TAB_CAROUSEL = "dds-hp-tab-carousel",
  DDS_PRODUCT_RECOMMENDER = "dds-product-recommender",
  DDS_CI_DESCRIBER = "dds-ci-describer",
  FORM_BUILDERV2 = "formBuilder",
  BREADCRUMBSV2 = "breadCrumbs",
  QUIZV2 = "quizComponent",
  EMAILPOPUPMODAL = "emailPopupModal",
  ROWCANVASV2 = "rowCanvas",
  FLOATINGWIDGETV2 = "floatingWidget",
  // W&C MUI5 Comps
  LONGFORMATCARD = "dtvLongFormatCard",
  CONTENTCARDS = "contentCard",
  PAGESECTIONHEADER = "dtvPageSectionHeader",
  PLANCARD = "dtvPlanCard",
  INPAGELEGAL = "dtvInPageLegal",
  INTERNALPRODCUTCOMPARISIONCHART = "internalProductComparisionChart",
  DTVHERO = "dtvHero",
  VERTICALSPACER = "dtvVerticalSpacer",
  HEADLINE = "dtvHeadline",
  LIST_ITEM = "dtvListItem",
  FOUR_UP_ICON_LIST = "dtv4UpIconListItem",
  MESSAGINGBANNER = "dtvMessagingBanner",
  MESSAGINGCARD = "dtvMessagingCard",
  EXTERNALSERVICECOMPARISON = "dtvExternalServiceComparison",
  EXTERNALSERVICECOMPARISONTABS = "dtvExternalServiceComparisonChartTabs",
  DTV1UP2UPMEDIA = "dtv1Up2UpMedia",
  DTVIFRAME = "iframe",
  DTVLINKFARM = "dtvLinkFarm",
  AGNOSTICPLANCARDS = "dtvAgnosticPlanCards",
  INSIDERARTICLE = "insiderPanel",
  FINDRETAILER = "findRetailer",
  CHANNELLOGOCAROUSAL = "channelLogoCarousal",
  DTVFIRSTNAME = "dtvFirstName",
  DTVTHREEUP = "dtvThreeUp",
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  LINKFOREST = "dtvLinkFarm",
  PACKAGECOMPARISONCALCULATOR = "PACKAGECOMPARISONCALCULATOR",
  LOCALCHANNELSLOOKUPPAGE = "LOCALCHANNELSLOOKUPPAGE",
  DTVFLASH = "dtvFlash",
  DTVCOUNTDOWN = "dtvCountDown",
  EXITMODAL = "exitModal",
  VIDEOMARQUEECAMPAIGN = "videoMarqueeCampaign",
  RSNLOOKUPTOOL = "RsnLookupTool",
  SITEMAP = "siteMap",
}

export interface ReportingDefaultsData {
  [key: string]: any;
}
export const LINK_POSITION_BODY = "Body";
export const ReportingDefaults: ReportingDefaultsData = {
  // ⚠ ONE ENTRY PER DDS ORGANISM, with the enum keys above. The names are
  // provisional pending the analytics team, so they are self-describing and
  // trivially swappable; what is not provisional is that none of them shares a
  // key with a v2 component.
  "dds-faq": {
    contentFriendlyName: `dds-faq`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-marquee-media": {
    contentFriendlyName: `dds-marquee-media`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-parallax-marquee": {
    contentFriendlyName: `dds-parallax-marquee`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-marquee-parallax-video": {
    contentFriendlyName: `dds-marquee-parallax-video`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-plan-card-carousel": {
    contentFriendlyName: `dds-plan-card-carousel`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-content-card-carousel": {
    contentFriendlyName: `dds-content-card-carousel`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-grow-card-carousel": {
    contentFriendlyName: `dds-grow-card-carousel`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-center-banner": {
    contentFriendlyName: `dds-center-banner`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-page-section-header": {
    contentFriendlyName: `dds-page-section-header`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-vertical-spacer": {
    contentFriendlyName: `dds-vertical-spacer`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-legal-modal": {
    contentFriendlyName: `dds-legal-modal`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-in-page-legal": {
    contentFriendlyName: `dds-in-page-legal`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-comparison-table": {
    contentFriendlyName: `dds-comparison-table`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-content-card-impact": {
    contentFriendlyName: `dds-content-card-impact`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-content-card-large": {
    contentFriendlyName: `dds-content-card-large`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-content-card-small": {
    contentFriendlyName: `dds-content-card-small`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-content-card-two-up": {
    contentFriendlyName: `dds-content-card-two-up`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-content-ribbon": {
    contentFriendlyName: `dds-content-ribbon`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-channel-lineup": {
    contentFriendlyName: `dds-channel-lineup`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-dynamic-recommender": {
    contentFriendlyName: `dds-dynamic-recommender`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-hp-tab-carousel": {
    contentFriendlyName: `dds-hp-tab-carousel`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  "dds-product-recommender": {
    contentFriendlyName: `dds-product-recommender`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  /* Sandbox tooling, not a marketing surface: the describer renders no link
     and no CTA, so it fires nothing and this entry never reaches a payload.
     It is here because the map↔reporting pairing is asserted for EVERY mapped
     organism (analytics-mapper.v3.spec.ts), and an organism with no key would
     be indistinguishable from one that lost its key by accident. */
  "dds-ci-describer": {
    contentFriendlyName: `dds-ci-describer`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  breadCrumbs: {
    contentFriendlyName: `breadCrumbs`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  carousel: {
    contentFriendlyName: `package card`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  faqPanel: {
    Infinity: {
      contentFriendlyName: `FAQ_PANEL`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  gvpPanel: {
    Infinity: {
      contentFriendlyName: `GVP_Panel`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  heroPanel: {
    Infinity: {
      contentFriendlyName: `Deals_Big_Brands_Bigger_Savings`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  quizComponent: {
    Infinity: {
      contentFriendlyName: `Deals_Quiz_Form`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  alert: {
    contentFriendlyName: `alertbanner`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  formBuilder: {
    contentFriendlyName: `formBuilder`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  cardgridlist: {
    contentFriendlyName: `package card`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  table: {
    contentFriendlyName: `table`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  canvas: {
    contentFriendlyName: `canvas`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  iframe: {
    contentFriendlyName: `iframe`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  channelsBoard: {
    contentFriendlyName: `channels board`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  floatingWidget: {
    Infinity: {
      contentFriendlyName: `floating widget`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  dtvExternalScriptLoader: {
    contentFriendlyName: `dtv-external-script-loader`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  UcgGalleryLoader: {
    contentFriendlyName: `ucg-gallery-loader`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  PkgComparisonModalV2: {
    contentFriendlyName: `pkg-compare-modal-V2`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvLongFormatCard: {
    contentFriendlyName: `dtv-long-format-card`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  contentCard: {
    contentFriendlyName: `dtv-content-card`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvMarquee: {
    contentFriendlyName: `dtv-marquee`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  rotatingMarque: {
    contentFriendlyName: `rotating-marque`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvCountDown: {
    contentFriendlyName: `dtv-countDown`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  VideoMarqueeCampaign: {
    contentFriendlyName: `dtv-VideoMarqueeCampaign`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  exitModal: {
    contentFriendlyName: `dtv-exitModal`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvEntertainmentCarousel: {
    contentFriendlyName: `dtv-carousel`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvFindRetailer: {
    contentFriendlyName: `dtv-find-retailer`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  internalProductComparisionChart: {
    contentFriendlyName: `dtv-internal-product-comparision-chart`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvPageSectionHeader: {
    contentFriendlyName: `dtv-page-section-header`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvPlanCard: {
    contentFriendlyName: `dtv-page-plan-card`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvInPageLegal: {
    contentFriendlyName: `dtv-in-page-legal`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvVerticalSpacer: {
    contentFriendlyName: `dtv-vertical-spacer`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvHeadline: {
    contentFriendlyName: `dtv-headline`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvListItem: {
    contentFriendlyName: `dtv-list-item`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtv4UpIconListItem: {
    contentFriendlyName: `dtv-4up-icon-list-item`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvHero: {
    Infinity: {
      contentFriendlyName: `dtv-hero`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  dtvMessagingBanner: {
    contentFriendlyName: `dtv-messaging-banner`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvMessagingCard: {
    contentFriendlyName: `dtv-messaging-card`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvMduHero: {
    contentFriendlyName: `dtv-mdu-hero`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvExternalServiceComparison: {
    contentFriendlyName: `dtv-external-service-comparison`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvExternalServiceComparisonChartTabs: {
    contentFriendlyName: `dtv-external-service-comparison-chart-tabs`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtv1Up2UpMedia: {
    Infinity: {
      contentFriendlyName: `dtv-1up-2up-media`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  dtviframe: {
    contentFriendlyName: `dtviframe`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvLinkFarm: {
    contentFriendlyName: `dtv-linkfarm`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvAgnosticPlanCards: {
    Infinity: {
      contentFriendlyName: `dtv-agnostic-plancards`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  insiderPanel: {
    Infinity: {
      contentFriendlyName: `INSIDER_PANEL`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  channelLogoCarousal: {
    contentFriendlyName: `channel-logo-carousal`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvFirstName: {
    contentFriendlyName: `First Name`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvThreeUp: {
    contentFriendlyName: `Three up component`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  PACKAGECOMPARISONCALCULATOR: {
    contentFriendlyName: `Package Comparision Savings Calculator`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  LOCALCHANNELSLOOKUPPAGE: {
    contentFriendlyName: `Local Channels Lookup Page`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  marketingBanner: {
    contentFriendlyName: `Marketing Banner`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  showCarousal: {
    contentFriendlyName: `Show Carousal`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  searchComponent: {
    ContentFriendlyName: `Search`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  searchWatchNow: {
    contentFriendlyName: `Search Watch Now`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  seoContent: {
    contentFriendlyName: `Seo Content`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  RsnLookupTool: {
    contentFriendlyName: `RSN Lookup Tool`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  LocalRsnTool: {
    contentFriendlyName: `Local RSN Tool`,
    contentProductGroup: ``,
    contentSystem: "SB"
  }
};
